export default {
    numeroPassaporte: 'Número Passaporte',
    nome: 'Nome',
    nomeCompleto: 'Nome Completo',
    nacionalidade: 'Nacionalidade',
    nascimento: 'Nascimento',
    email: 'Email',
    telefone: 'Telefone',
    informarContatoEmergencia: 'Informar contato emergência?',
    informarRestricoesDadosSaude: 'Informar restrições e dados de saúde?',
    restriçõesDadosSaude: 'Restrições e dados de saúde',
    menoresIdade: 'Para os menores de 14 anos a cobertura de Morte Acidental estará limitada ao reembolso de despesas com o funeral.',
    autorizacao: `Autorizo o uso dos meus dados pessoais para emissão do Seguro Aventura, e declaro
        que estou ciente e fui informado pelo promotor do evento dos riscos envolvidos na
        prática das atividades de turismo e esportes de aventura.`
}